import { PageShell } from "@/components/PageShell";
import { Overline } from "@/components/Reveal";
import { motion } from "framer-motion";
import { Mail, LifeBuoy, ShieldCheck, ArrowRight } from "lucide-react";

const channels = [
  {
    icon: Mail,
    label: "Contato comercial",
    email: "contato@rodeia.com.br",
  },
  {
    icon: LifeBuoy,
    label: "Suporte",
    email: "suporte@rodeia.com.br",
  },
  {
    icon: ShieldCheck,
    label: "Privacidade e proteção de dados",
    email: "privacidade@rodeia.com.br",
  },
];

const Contato = () => {
  return (
    <PageShell>
      <section className="relative pt-36 md:pt-44 pb-28 md:pb-40">
        <div className="absolute inset-0 grid-lines opacity-40 pointer-events-none" />
        <div className="relative mx-auto max-w-[1100px] px-6 md:px-10">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          >
            <Overline>Contato</Overline>
            <h1 className="font-display font-extrabold text-4xl md:text-6xl tracking-tighter leading-[1.0] mt-6">
              Fale com a RODE IA
            </h1>
            <p className="text-neutral-400 text-lg leading-relaxed mt-8 max-w-[56ch]">
              Para conversar sobre automação, integração de sistemas, parcerias
              ou suporte, utilize um dos canais abaixo.
            </p>
          </motion.div>

          <div className="mt-14 grid md:grid-cols-3 gap-[1px] bg-white/10 border border-white/10 rounded-sm overflow-hidden">
            {channels.map((c, i) => {
              const Icon = c.icon;
              return (
                <div key={i} className="bg-[#0a0a0a] p-7 md:p-9">
                  <Icon className="h-6 w-6 text-white" strokeWidth={1.3} />
                  <h2 className="font-display font-bold text-lg mt-5">{c.label}</h2>
                  <a
                    href={`mailto:${c.email}`}
                    data-testid={`contato-email-${i}`}
                    className="mt-2 inline-block text-neutral-300 hover:text-white text-sm underline underline-offset-4 break-all"
                  >
                    {c.email}
                  </a>
                </div>
              );
            })}
          </div>

          <div className="mt-10 flex flex-col sm:flex-row sm:items-center gap-6 justify-between border border-white/10 bg-[#0a0a0a] rounded-sm p-7 md:p-9">
            <div>
              <h2 className="font-display font-bold text-xl md:text-2xl tracking-tight">
                Solicitar mapeamento de processo
              </h2>
              <p className="text-neutral-400 text-sm mt-2 max-w-[52ch]">
                Descreva brevemente o processo que mais consome tempo hoje e
                retornaremos com os próximos passos.
              </p>
            </div>
            <a
              href="mailto:contato@rodeia.com.br?subject=Mapeamento%20de%20processo"
              data-testid="contato-mapeamento-button"
              className="group shrink-0 inline-flex items-center justify-center gap-2 bg-white text-black font-semibold px-7 py-4 rounded-sm hover:bg-neutral-200 active:scale-95 transition-all"
            >
              Solicitar mapeamento de processo
              <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>

          <div className="mt-12 font-mono text-xs text-neutral-500 leading-relaxed">
            <p>RODE IA LTDA</p>
            <p>CNPJ 68.764.921/0001-64</p>
          </div>
        </div>
      </section>
    </PageShell>
  );
};

export default Contato;
